import { EventPositionDTO } from "@/pages/admin/events/types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface PositionSelectorProps {
  eventPositions: EventPositionDTO[];
  selectedPositionId: string;
  onSelectPosition: (positionId: string) => void;
}

export function PositionSelector({
  eventPositions,
  selectedPositionId,
  onSelectPosition,
}: PositionSelectorProps) {
  return (
    <div className="space-y-2">
      <label htmlFor="position" className="text-sm font-medium">
        Select Position
      </label>
      <Select value={selectedPositionId} onValueChange={onSelectPosition}>
        <SelectTrigger>
          <SelectValue placeholder="Select a position" />
        </SelectTrigger>
        <SelectContent>
          {eventPositions.map((position) => {
            const totalRequired =
              position.employeesRequired * position.quantity;
            const assigned = position.signedUpUsers?.length || 0;
            const remaining = totalRequired - assigned;

            return (
              <SelectItem
                key={position.eventPositionId}
                value={position.eventPositionId}
                disabled={remaining <= 0}
              >
                {position.tableName} ({assigned}/{totalRequired})
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
}
